export default __webpack_public_path__ + "static/media/sticker-k.3101e709.png";